
























































































































































import { Component, Mixins } from "vue-mixin-decorator";
import { Prop, Watch } from "vue-property-decorator";
import SCheck from "@/app/basic/common/components/SCheck.vue";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import CardDeckSubContainerComponent from "@/app/basic/card/builder/CardDeckSubContainerComponent.vue";
import {
  createRectangle,
  createSize
} from "@/app/core/utility/CoordinateUtility";
import ComponentVue from "@/app/core/window/ComponentVue";
import SButton from "@/app/basic/common/components/SButton.vue";
import ColorPickerComponent from "@/app/core/component/ColorPickerComponent.vue";
import TrColorPickerComponent from "@/app/basic/common/components/TrColorPickerComponent.vue";
import { CardMeta } from "@/@types/gameObject";
import CardSimulatorComponent from "@/app/basic/card/builder/CardSimulatorComponent.vue";
import CardComponent from "@/app/basic/card/CardComponent.vue";
import VueEvent from "@/app/core/decorator/VueEvent";
import { StoreUseData } from "@/@types/store";
import ImagePickerComponent from "@/app/core/component/ImagePickerComponent.vue";
import TrStringInputComponent from "@/app/basic/common/components/TrStringInputComponent.vue";
import GameObjectManager from "@/app/basic/GameObjectManager";
import { createEmptyStoreUseData } from "@/app/core/utility/Utility";
import TrNumberInputComponent from "@/app/basic/common/components/TrNumberInputComponent.vue";
const uuid = require("uuid");

@Component({
  components: {
    SCheck,
    CardSimulatorComponent,
    SButton,
    CardComponent,
    TrStringInputComponent,
    TrColorPickerComponent,
    TrNumberInputComponent,
    ColorPickerComponent,
    CardDeckSubContainerComponent,
    ImagePickerComponent
  }
})
export default class CardDeckCreateCardComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: Number, required: true })
  private width!: number;

  @Prop({ type: Number, required: true })
  private height!: number;

  @Prop({ type: Number, required: true })
  private padTop!: number;

  @Prop({ type: Number, required: true })
  private padHorizontal!: number;

  @Prop({ type: Number, required: true })
  private padBottom!: number;

  @Prop({ type: Number, required: true })
  private radius!: number;

  @Prop({ type: String, required: true })
  private frontBackgroundColorDefault!: string;

  @Prop({ type: String, required: true })
  private backImage!: string;

  @Prop({ required: true })
  private imageTag!: string | null;
  @Watch("imageTag")
  private onChangeImageTag() {
    this.currentTag = this.imageTag;
  }

  @Prop({ type: String, required: true })
  private backBackgroundColor!: string;

  @Prop({ type: String, required: true })
  private fontColor!: string;

  @Prop({ type: Number, required: true })
  private nameHeight!: number;

  @Prop({ type: Number, required: true })
  private nameFontSizeDefault!: number;

  @Prop({ type: String, required: true })
  private nameBackgroundColorDefault!: string;

  @Prop({ type: Number, required: true })
  private textHeight!: number;

  @Prop({ type: Number, required: true })
  private textFontSizeDefault!: number;

  @Prop({ type: Number, required: true })
  private textPaddingDefault!: number;

  @Prop({ type: String, required: true })
  private textBackgroundColor!: string;

  @Prop({ type: Array, required: true })
  private cardList!: StoreUseData<CardMeta>[];

  private frontBackgroundColor: string = "#ffffff";
  private nameFontSize: number = 20;
  private nameBackgroundColor: string = "rgba(0, 0, 0, 0)";
  private textFontSize: number = 11;
  private textPadding: number = 0;
  private name: string = "";
  private text: string = "";

  private searchText: string = "";
  private isViewCardImage: boolean = true;

  @VueEvent
  private get useCardList() {
    if (!this.searchText) return this.cardList.concat();
    const regExt = new RegExp(this.searchText);
    return this.cardList.filter(c => c.data!.name.match(regExt));
  }

  @LifeCycle
  private mounted() {
    this.setDefault();
    this.currentTag = this.imageTag;
  }

  @VueEvent
  private getCardSize(cardMeta: CardMeta) {
    return createSize(cardMeta.width, cardMeta.height);
  }

  private setDefault() {
    this.frontBackgroundColor = this.frontBackgroundColorDefault;
    this.nameFontSize = this.nameFontSizeDefault;
    this.nameBackgroundColor = this.nameBackgroundColorDefault;
    this.textFontSize = this.textFontSizeDefault;
    this.textPadding = this.textPaddingDefault;
    this.currentImageId = "";
    this.name = "";
    this.text = "";
  }

  private currentImageId: string = "";
  private currentTag: string | null = null;
  private mediaList = GameObjectManager.instance.mediaList;

  @VueEvent
  private getImageUrl(mediaId: string): string {
    const media = this.mediaList.filter(m => m.id === mediaId)[0];
    if (!media) return "";
    return `url(${media.data!.url})`;
  }

  @VueEvent
  private addCard() {
    const id: string = uuid.v4();
    this.cardList.push(
      createEmptyStoreUseData(id, {
        width: this.width,
        height: this.height,
        padHorizontal: this.padHorizontal,
        padTop: this.padTop,
        padBottom: this.padBottom,
        radius: this.radius,
        frontImage: this.getImageUrl(this.currentImageId),
        frontBackgroundColor: this.frontBackgroundColor,
        backImage: this.getImageUrl(this.backImage),
        backBackgroundColor: this.backBackgroundColor,
        fontColor: this.fontColor,
        name: this.name,
        nameHeight: this.nameHeight,
        nameFontSize: this.nameFontSize,
        nameBackgroundColor: this.nameBackgroundColor,
        text: this.text,
        textHeight: this.textHeight,
        textFontSize: this.textFontSize,
        textPadding: this.textPadding,
        textBackgroundColor: this.textBackgroundColor
      })
    );
    this.setDefault();
    window.console.log(JSON.stringify(this.cardList, null, "  "));
  }

  private hoverCardId: string | null = null;

  @VueEvent
  private onHoverCard(
    card: StoreUseData<CardMeta>,
    isHover: boolean,
    elm: HTMLElement
  ) {
    this.hoverCardId = isHover ? card.id! : null;
    const rect = elm.getBoundingClientRect();
    const r = createRectangle(rect.x, rect.y, rect.width, rect.height);
    this.$emit("hover-card", card, isHover, r);
  }

  @VueEvent
  private deleteCard(cardId: string) {
    const idx = this.cardList.findIndex(c => c.id === cardId);
    this.cardList.splice(idx, 1);
  }
}
